import { apiClient } from './apiClient';

export const medalTableService = {
  // Medaillenspiegel abrufen
  getMedalTable: async () => {
    try {
      const data = await apiClient.get('/results/medals/table');
      return data;
    } catch (error) {
      console.error('Fehler beim Laden des Medaillenspiegels:', error);
      throw error;
    }
  }
}; 